import { createContext, useContext, useState, useEffect } from 'react'
import { useAuth } from './AuthProvider'

interface DopaWidgetContextType {
  isWidgetEnabled: boolean
  toggleWidget: () => void
}

const DopaWidgetContext = createContext<DopaWidgetContextType | undefined>(undefined)

export const useDopaWidget = () => {
  const context = useContext(DopaWidgetContext)
  if (!context) {
    throw new Error('useDopaWidget must be used within a DopaWidgetProvider')
  }
  return context
}

export const DopaWidgetProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, profile } = useAuth()
  const [isWidgetEnabled, setIsWidgetEnabled] = useState(true)

  // Load widget preference from localStorage or profile
  useEffect(() => {
    if (user && profile) {
      // In a full implementation, this would come from Supabase ui_settings table
      // For now, use localStorage
      const savedPreference = localStorage.getItem('dopa_widget_enabled')
      if (savedPreference !== null) {
        setIsWidgetEnabled(savedPreference === 'true')
      }
    } else {
      // For non-authenticated users, check localStorage
      const savedPreference = localStorage.getItem('dopa_widget_enabled')
      if (savedPreference !== null) {
        setIsWidgetEnabled(savedPreference === 'true')
      }
    }
  }, [user, profile])

  const toggleWidget = () => {
    const newValue = !isWidgetEnabled
    setIsWidgetEnabled(newValue)
    localStorage.setItem('dopa_widget_enabled', newValue.toString())
    
    // In a full implementation, also save to Supabase ui_settings table
    // if (user) {
    //   updateUISettings(user.id, { dopa_widget_enabled: newValue })
    // }
  }

  return (
    <DopaWidgetContext.Provider value={{
      isWidgetEnabled,
      toggleWidget
    }}>
      {children}
    </DopaWidgetContext.Provider>
  )
}